<template>
    <div class="body">
        <transition appear>
          <div v-if="!reportData" class="zhezhao">
              <div class="image" style="width: 100%; height: 13%">
                <img src="@/assets/logo1.png" style="width: 217px; height: 77px; margin-left: 7px"/>
              </div>

              <div class="right" style="width: 100%; height: 87%">
                <p class="font1" style="font-size: 86px; margin-top: 20vh;"> 2024富学宝典</p>
                <p class="font1" style=" color: #e873a0;font-size: 71px;margin-top: 20px;"> 一月学习报告 </p>
                <p class="font1" style="font-size: 41px;margin-top: 27px;"> 坚持学习的人永葆青春 </p>
               
                <div v-show="!Loading" class="input-container" style="margin-top: 4vh">
                  <input v-model="jobNo" type="text" id="input" required="" />
                  <label for="input" class="label">请输入工号</label>
                  <div class="underline"></div>
                </div>
                <div v-show="!Loading" style="display: flex; justify-content: center;margin-top:40px;">
                  <button class="button" @click="inputJobNo()">NEXT</button>
                </div>
                <!-- <LoadingAuguest v-show="Loading" style="margin-top: 30vh" /> -->
              </div>
          </div>
        </transition>
        <main v-if="reportData && reportData.studate != 0" id="main" ref="scrollDiv" class="view">
          <section id="section01" class="section">
              <!-- 有学习天数，有学分 -->
              <div v-if="reportData.studate > 0 && reportData.creditvalue > 0" style="display: flex; flex-wrap: wrap">
                <div class="left" style="width: 100%; margin-top: 10vh">
                  <p class="font1" style="font-size: 30px; margin-top: 21px;">Hi～<span class="font2" style="font-size: 36px;">{{ reportData.stuname }}</span>，我们又见面啦</p>
                  <p class="font1" style="font-size: 30px; margin-top: 15px;"><span class="font2" style="font-size: 36px;">2024</span>年<span class="font2" style="font-size: 36px;">1</span>月</p>

                  <p class="font1" style="font-size: 30px;margin-top: 15px;">你已经学习了<span class="font2" style="font-size: 32px;">{{ reportData.studate }}</span>天</p>
                  <p class="font1" style="font-size: 30px;margin-top: 15px;">累计学习了<span class="font2" style="font-size: 28px;">{{ reportData.playtime }}</span >小时</p>

                  <p class="font1" style="font-size: 30px;margin-top: 15px;">学习了<span class="font2" style="font-size: 28px;">{{ reportData.creditvalue }}</span >门课程</p>
                  <p class="font1" style="font-size: 36px;text-align: center;margin-top: 45px;">完成了<span class="font2" style="font-size: 28px;">{{ reportData.creditvalue }}</span >门课程</p>

                  <p class="font1" style="font-size: 30px;margin-top: 15px;">累计考试<span class="font2" style="font-size: 28px;">{{ reportData.creditvalue }}</span >次</p>
                  <p class="font1" style="font-size: 36px;text-align: center;margin-top: 45px;">获得学分<span class="font2" style="font-size: 28px;">{{ reportData.creditvalue }}</span >分</p>
                </div>
              </div>

              <!-- 有学习天数，没有学分 -->
              <div v-if="reportData.studate > 0 && !reportData.creditvalue" style="display: flex; flex-wrap: wrap">
                <div class="left" style="width: 100%; margin-top: 10vh">
                  <p class="font1" style="font-size: 30px; margin-top: 21px;">Hi～<span class="font2" style="font-size: 36px;">{{ reportData.stuname }}</span>，我们又见面啦</p>
                  <p class="font1" style="font-size: 30px; margin-top: 15px;"><span class="font2" style="font-size: 36px;">2024</span>年<span class="font2" style="font-size: 36px;">1</span>月</p>

                  <p class="font1" style="font-size: 30px;margin-top: 15px;">这一年，你在富学宝典平台上的总学习天数达到了<span class="font2" style="font-size: 28px;">{{ reportData.studate }}</span >天</p>
                  <p class="font1" style="font-size: 30px;margin-top: 15px;">但是还没有获得学分，请继续加油！</p>
                  <p class="font2" style="font-size: 36px;text-align: center;margin-top: 45px;">{{ reportData.textLab.text }}</p>
                </div>
              </div>

               <!-- 没有学习天数，没有学分 -->
              <div v-if="!reportData.studate && !reportData.creditvalue" style="display: flex; flex-wrap: wrap">
                <div class="left" style="width: 100%; margin-top: 20vh">
                  <p class="font1" style="font-size: 30px; margin-top: 21px;">Hi～<span class="font2" style="font-size: 36px;">{{ reportData.stuname }}</span>，我们又见面啦</p>
                  <p class="font1" style="font-size: 30px; margin-top: 15px;"><span class="font2" style="font-size: 36px;">2024</span>年<span class="font2" style="font-size: 36px;">1</span>月</p>

                  <p class="font1" style="font-size: 30px;margin-top: 15px;">你还没有在富学宝典上学习，请继续加油！</p>
                  <p class="font2" style="font-size: 36px;text-align: center;margin-top: 45px;">{{ reportData.textLab.text }}</p>
                </div>
              </div>
          </section>


          <section id="section02" class="section">
              <div class="page2" style="display: flex; flex-wrap: wrap">
                <div class="right" style="width: 100%; margin-top: 10vh">
                  <p class="font2" style="font-size: 30px; margin-top: 21px;text-align: center;">问渠哪得清如许，</p>
                  <p class="font2" style="font-size: 30px; margin-top: 21px;text-align: center;">为有源头活水来。</p>

                  <p class="font1" style="font-size: 30px;margin-top: 21px;">2023年富学宝典上热门课程推荐：</p>
                  <div style="width: 100%;margin: 0 auto;text-align: center;margin-top: 2vh;font-size: 30px;color: #fff;">
                     <p @click="redirectToBook(0)" class="font1" style="margin-top: 1vh;">{{this.book[0].Name}}&nbsp;&nbsp;<i class="fa fa-arrow-right fa-lg" style="color:#fff;"></i></p>
                     <p @click="redirectToBook(1)" class="font1" style="margin-top: 1vh;">{{this.book[1].Name}}&nbsp;&nbsp;<i class="fa fa-arrow-right fa-lg" style="color:#fff;"></i></p>
                     <p @click="redirectToBook(2)" class="font1" style="margin-top: 1vh;">{{this.book[2].Name}}&nbsp;&nbsp;<i class="fa fa-arrow-right fa-lg" style="color:#fff;"></i></p>
                     <p @click="redirectToBook(3)" class="font1" style="margin-top: 1vh;">{{this.book[3].Name}}&nbsp;&nbsp;<i class="fa fa-arrow-right fa-lg" style="color:#fff;"></i></p>
                     <p @click="redirectToBook(4)" class="font1" style="margin-top: 1vh;">{{this.book[4].Name}}&nbsp;&nbsp;<i class="fa fa-arrow-right fa-lg" style="color:#fff;"></i></p>
                     <p @click="redirectToBook(5)" class="font1" style="margin-top: 1vh;">{{this.book[5].Name}}&nbsp;&nbsp;<i class="fa fa-arrow-right fa-lg" style="color:#fff;"></i></p>
                  </div>
                </div>
              </div>
          </section>

          <section id="section03" class="section">
              <div style="display: flex; flex-wrap: wrap">
                <div class="right" style="width: 100%; margin-top: 10vh">
                  <p class="font2" style="font-size: 30px; margin-top: 21px;text-align: center;">千淘万沥虽辛苦，</p>
                  <p class="font2" style="font-size: 30px; margin-top: 21px;text-align: center;">吹尽黄沙始到金。</p>
                  <div>
                    <p class="font1" style="margin: 0 auto; font-size: 30px;color: #fff;text-align: center;margin-top: 3vh;">2024年必修课程：</p>
                    <ul style="margin: 0 auto; font-size: 30px;color: #953b5d;;text-align: center;margin-top: 3vh;">
                      <li>《反贪腐（风清气正）2024》</li>
                      <li>《行为准则（COC）简介-2024》</li>
                    </ul>
                    <p style="width: 100%;margin: 0 auto;font-size: 15px;color: #000;margin-top: 3vh;text-align: center;">**具体可登录富学宝典查看:【首页】>【个人设置】>【学习任务】**</p>
                  </div>
                  <div style="margin-top: 3vh;" v-if="this.grade=== '师4'">
                      <p style="width: 80%;margin: 0 auto; font-size: 30px;color: #fff;text-align: center;margin-top: 3ch;">晋升<a style="font-size: 35px;color: #953b5d;">{{this.grade}}</a>必修课程完成情况：</p>
                      <div style="display: flex;width:90%;margin:0 auto;justify-content: center;background-color: rgb(226, 145, 226,0.3);">
                        <div style="width: 30%;text-align: center;">
                          <p style="margin:0;color: #000;font-size: 1.47em;margin-bottom: 0;"><a style="color: #953b5d;">{{this.scoreC}}</a>/30.5</p>
                          <p style="margin: 0;color: #000;">必修学分</p>
                        </div>
                        <div style="width: 30%;text-align: center;">
                          <p style="margin: 0;color: #000;font-size: 1.47em;margin-bottom: 0;"><a style="color: #953b5d;">{{this.scoreE}}</a>/8</p>
                          <p style="margin: 0;color: #000;">选修学分</p>
                        </div>
                        <div style="width: 30%;text-align: center;">
                          <p v-if="this.status ===true" style="margin: 0;color: #000;font-size: 1.47em;margin-bottom: 0;"><i class="fa fa-check" style="color:#953b5d;"></i></p>
                          <p v-if="this.status ===false" style="margin: 0;color: #000;font-size: 1.47em;margin-bottom: 0;"><i class="fa fa-times" style="color:#953b5d;"></i></p>
                          <p style="margin: 0;color: #000e;">达标状态</p>
                        </div>
                      </div>
                  </div>
                  <div style="margin-top: 3vh;" v-if="this.grade=== '师8'">
                      <p style="width: 80%;margin: 0 auto; font-size: 30px;color: #fff;text-align: center;margin-top: 3ch;">晋升<a style="font-size: 35px;color: #953b5d;">{{this.grade}}</a>必修课程完成情况：</p>
                      <div style="display: flex;width:90%;margin:0 auto;justify-content: center;background-color: rgb(226, 145, 226,0.3);">
                        <div style="width: 30%;text-align: center;">
                          <p style="margin:0;color: #000;font-size: 1.47em;margin-bottom: 0;"><a style="color: #953b5d;">{{this.scoreC}}</a>/51.5</p>
                          <p style="margin: 0;color: #000;">必修学分</p>
                        </div>
                        <div style="width: 30%;text-align: center;">
                          <p style="margin: 0;color: #000;font-size: 1.47em;margin-bottom: 0;"><a style="color: #953b5d;">{{this.scoreE}}</a>/8</p>
                          <p style="margin: 0;color: #000;">选修学分</p>
                        </div>
                        <div style="width: 30%;text-align: center;">
                          <p v-if="this.status ===true" style="margin: 0;color: #000;font-size: 1.47em;margin-bottom: 0;"><i class="fa fa-check" style="color:#953b5d;"></i></p>
                          <p v-if="this.status ===false" style="margin: 0;color: #000;font-size: 1.47em;margin-bottom: 0;"><i class="fa fa-times" style="color:#953b5d;"></i></p>
                          <p style="margin: 0;color: #000e;">达标状态</p>
                        </div>
                      </div>
                  </div>
                  <p v-if="reportData.status!== null" style="width: 90%;margin: 0 auto;text-align: center; font-size: 15px;color: #fff;margin-top: 3vh;">具体可登录富学宝典查看:【首页】>【个人设置】>【晋升课程】</p>
                </div>
              </div>
          </section>

          <section id="section04" class="section">
              <div class="page4"  style="display: flex; flex-wrap: wrap">
                <div class="title"><p class="font1" style="font-size: 60px;">好书推荐</p></div>
                    <div class="left" style="margin-top: 40px;width: 80%;margin: 0 auto;">
                        <div class="detail">
                            <p style="text-align: center;font-size: 30px;font-family: font1;color: white;">《完全图解云计算》</p>
                            <p class="font2" style="font-size: 18px;text-align: center;">西村泰洋</p>
                        </div>
                        <div class="bookDetail" style="font-size: 17px;padding: 20px;color: #fff;">
                            <span style="font-size: 20px;">
                               云计算作为信息通信技术的基础，已经成为不可或缺的存在，人工智能、物联网、大数据及其他各类应用场景，也都需要云计算提供的基础设施的支持才能正常运行，可以说云计算是目前最炙手可热、且广泛应用的互联网技术之一。<br><br>
                              《完全图解云计算》就以图解的形式，对云服务的构建技术、移动技术和安全性三个方面进行了详细解说。<br><br>  
                               通过本书学习，读者可以掌握云是什么，云的作用，云计算的工作原理和云服务如何部署等，从思维方式到技术、运用方法等面面俱到。特别适合作为大中专院校信息通信专业的教学参考书，也适合对云计算感兴趣，想从事相关工作的 IT 技术人员学习。<br><br>  
                               另外，本书还特别适合从事相关工作的商务人士、相关公司的管理和开发人员了解云计算和云服务知识。<br><br>  
                            </span>
                        </div>
                    </div>
                    <div class="right" style="margin-top: 40px;width: 80%;margin: 0 auto;">
                        <div class="detail">
                          <p style="text-align: center;font-size: 30px;font-family: font1;color: white;">《智慧空间》</p>
                          <p class="font2" style="font-size: 18px;text-align: center;">[美]加布里埃尔·雷内，[美]丹·马普斯</p>
                        
                        </div>
                        <div class="bookDetail" style="font-size: 17px;padding: 20px;">
                          <span style="font-size: 20px;text-align: justify;color:#fff;">
                              本书首先回顾了互联网的诞生以及从PC互联到移动互联的发展历程； 然后结合区块链、人工智能、增强现实/虚拟现实、物联网、5G等多种技术的最新成果，揭示在这些先进技术的支撑下，下一代互联网将走向空间化的必然趋势；之后，深入地分析了现有的万维网因其存在的结构性缺陷，将无法承载未来发展，进而详细阐述如何将多种技术融合为一，搭建一个完整的智能空间网络的构思。<br><br>
                              本书还就如何将这一全新的网络架构应用于城市管理、建筑/工业设计、仓储物流管理、广告及电子商务提出了具体设想。<br><br>
                          </span>
                        </div>
                    </div>         
              </div>
          </section>

          <section id="section05" class="section">
              <div class="page5" style="position: relative;top: 10vh;">
                    <div style="margin: 0 auto;margin-top: 10vh">
                        <p class="font1" style="font-size: 30px; text-align: center;">你希望在富学宝典平台上遇见哪些好课程呢?</p>
                        <p class="font1"  style="font-size: 28px;text-align: center;margin-top: 2vh;">请写下你的学习清单吧！</p>
                        <form id="form" class="topBefore">
                            <textarea id="message" v-model="comment" type="text" placeholder="MESSAGE"></textarea>
                            <input id="submit"  @click="submit" type="button" value="OK!" />
                        </form>
                    </div>
                    <div style="padding-top: 70px;margin: 0 auto;">
                        <p style="font-size: 48px;text-align: center;color: white;">THANK YOU!</p>
                        <p class="font1" style="font-size: 48px;text-align: center;">一旦决心学习，谁也拦不住你</p>
                    </div>
              </div>
          </section>
        </main>
    </div>
</template>

<script>
import Loading from './Loading.vue'
import viewApi from "@/api/view";
import dataApi from "@/api/data";
import { getArray } from "../../utils/encourage";
export default {
    data(){
      return{
        viewId: "",
        Loading:false,
        reportData:'',
        jobNo:'',
        comment: "",
        source: "",

        book:'',
        grade:'',
        scoreC:'',
        scoreE:'',
        status:''

      }
    },
    created(){
      document.title = "一月学习报告";
      /* 相信数据begin */
      var test = window.location.href
      let arr = test.split("?code=")
      this.code = arr[1]
      if (this.code) {
        viewApi.getJobNoByBelieve(this.code).then((res) => {
          if(res.data.code === 200) {
            this.jobNo = res.data.data.jobNo
            this.source = "相信"
            if (this.jobNo) {
              this.Loading = true;
              this.getData()
            }
          }
        })
      }
      /* 相信数据end */
    },
    methods:{
      submit() {
      if (!this.comment) {
        this.$message({
          message: "请说说您的学习计划",
          type: "warning",
          center: true,
        });
      } else if (this.comment) {
        const view = {
          comment: this.comment,
          studyList: this.studyList,
        };
        view["id"] = this.viewId;
        console.log(view);
        viewApi.update(view).then((res) => {
          if (res) {
            this.$message({
              message: "提交成功，感谢您的留言。",
              type: "success",
              center: true,
            });
          }
        });
      }
      },
      inputJobNo() {
            if (this.Loading === true) {
              return;
            }
            if (this.jobNo) {
              this.Loading = true;
              this.getData();
            } else {
              this.$message({
                message: "请输入工号",
                type: "warning",
                center: true,
              });
            }
      },
      getData() {
            dataApi.getDataFor24January(this.jobNo).then((res) => {
              this.reportData = res.data.data.data;
              console.log(res.data.data.data);

              this.book=JSON.parse(this.reportData.recommend)
              const status=JSON.parse(this.reportData.status)
              if(status !== null){
                  this.grade=status[0].grade
                  this.scoreC=status[0].C
                  this.scoreE=status[0].E
                  this.status=status[0].status
                }

              if (this.reportData) {
                this.sendViewRecords();
                // this.Loading = false;
                this.reportData.textLab = getArray(this.reportData.textLab);
              } else if (!this.reportData) {
                this.$message({
                  message: "抱歉，暂时找不到您的学习报告！",
                  type: "warning",
                  center: true,
                });
                this.Loading = false;
              }
            });
      },
      sendViewRecords() {
          if (this.jobNo) {
            let viewData = {
              jobNo: this.jobNo,
              device: "PC",
              type: 14,
              browser: this.browser,
            };
            if (this.source) {
              viewData["source"] = this.source;
            }
            viewApi.view(viewData).then((res) => {
              this.viewId = res.data.data.data.id;
            });
          } else {
            return;
          }
      },
      redirectToBook(id){
        const book=this.book[id]
        const view={
            clickCourseName:book.Name,
            clickCourseLink:book.link
        }
        view["id"] = this.viewId;
        viewApi.update(view).then((res) => {
          if (res.data.code===200) {
            window.location.href = view.clickCourseLink;
          }
        });
      }
    },
    mounted(){
     
    }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
/* 字体样式 */
.font1{
  color: white; 
  font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  font-weight: 700; 
  text-align: center;
}
.font2{
  color: #953b5d; 
  font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  font-weight: 700; 
}

.font3{
  color: #953b5d; 
  font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  text-align: center;
}
/* 第一页 */
.body {
  width: 100vw;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
}

.zhezhao {
  width: 100vw;
  height: 100vh;
  /* background-image: linear-gradient(170deg, #b55d7f , #953b5d); */
  background:url("../../assets/24January/bg2.jpg")  no-repeat;
  background-size: 100% 100%,cover;
  position: absolute;
  display: flex;
  flex-wrap: wrap;
}
.input-container {
  position: relative;
  margin: 50px auto;
  width: 400px;
}

.input-container input[type="text"] {
  font-size: 20px;
  width: 100%;
  border: none;
  border-bottom: 2px solid #ccc;
  padding: 5px 0;
  background-color: transparent;
  outline: none;
  color: #fcc741;
}

.input-container .label {
  position: absolute;
  top: 0;
  left: 0;
  color: #ccc;
  transition: all 0.3s ease;
  pointer-events: none;
}

.input-container input[type="text"]:focus ~ .label,
.input-container input[type="text"]:valid ~ .label {
  top: -20px;
  font-size: 16px;
  color: #ffa6a2;
}

.input-container .underline {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 2px;
  width: 100%;
  background-color: #ffa6a2;
  transform: scaleX(0);
  transition: all 0.3s ease;
}

.input-container input[type="text"]:focus ~ .underline,
.input-container input[type="text"]:valid ~ .underline {
  transform: scaleX(1);
}
.button {
  --bg: #953b5d;
  --text-color: #fff;
  position: relative;
  width: 150px;
  height: 40px;
  border: none;
  background: var(--bg);
  color: var(--text-color);
  padding: 1em;
  font-weight: bold;
  text-transform: uppercase;
  transition: 0.2s;
  border-radius: 5px;
  opacity: 0.8;
  letter-spacing: 1px;
  box-shadow: #bd5e82 0px 7px 2px, #000 0px 8px 5px;
}

.button:hover {
  opacity: 1;
}

.button:active {
  top: 4px;
  box-shadow: #6e2441 0px 3px 2px, #000 0px 3px 5px;
}

/* 第二页 */
.view {
  width: 100%;
  height: 100%;
  background:url("../../assets/24January/bg2.jpg")  no-repeat;
  background-size: 100% 100%,cover;
  /* background-image: linear-gradient(170deg, #7a94ac , #a2bed8); */
}
main {
  scroll-snap-type: y mandatory;
  scroll-padding: 80px;
  overflow: scroll;
  height: 100vh;
}
section {
  width: 100vw;
  height: 100vh;
  scroll-snap-align: start;
}
#section01,#section02,#section03,#section04{
  position: relative;
}
ul{
    list-style-type: none;
    padding: 0;
    color: #fff;
    text-align: center;
}
li {
    align-items: center;
    margin-bottom: 8px; 
}

/* li::before {
    content: '\2022'; 
    color: #fff;
    font-size: 1.5em;
    margin-right: 3px; 
    margin: 0 auto;
} */

/*书籍推荐页 */
.title {
  font-size: 50px;
  width: 100%;
  margin-bottom: 30px;
  margin-top: 30px;
}


/* 最后的输入框 */
#form {
  position: relative;
  width: 40vw;
  padding-top: 50px;
  margin: 0 auto;
}

input {
  font-family: "Lato", sans-serif;
  font-size: 0.875em;
  width: 570px;
  height: 50px;
  padding: 0px 15px 0px 15px;
  background: transparent;
  outline: none;
  color: #ffffff;
  border: solid 1px #fff;
  border-bottom: none;
  transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
}

input:hover {
  background: #fff;
  color: #fff;
}

textarea {
  width: 40vw;
  max-width: 40vw;
  height: 20vh;
  max-height: 20vh;
  padding: 0;
  background: transparent;
  outline: none;
  color: #fff;
  font-family: "Lato", sans-serif;
  font-size: 0.875em;
  border: solid 1px #fff;
  transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
}

/* textarea:hover {
  background: #e89fbb;
  color: #fff;
} */

#submit {
  width:  40vw;
  padding: 0;
  margin: -5px 0px 0px 0px;
  font-family: "Lato", sans-serif;
  font-size: 0.875em;
  color: #000;
  outline: none;
  cursor: pointer;
  border: solid 1px #fff;
  border-top: none;
}

#submit:hover {
  color: #b3aca7;
}
/* 

*/
</style>